import { render, staticRenderFns } from "./PaymentDone.vue?vue&type=template&id=0500ce65&scoped=true&"
import script from "./PaymentDone.vue?vue&type=script&lang=js&"
export * from "./PaymentDone.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDone.vue?vue&type=style&index=0&id=0500ce65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500ce65",
  null
  
)

export default component.exports